// src/services/walletService.js
import api from './api';

const getBalance = () => {
  return api.get('/wallet/balance');
};

const getLedger = (params = {}) => {
  return api.get('/wallet/ledger', { params });
};

const verifyLedger = () => {
  return api.get('/wallet/ledger/verify');
};

const deposit = (amount) => {
  return api.post('/wallet/deposit', { amount });
};

const createCheckout = (payload) => {
  return api.post('/wallet/checkout', payload);
};

const walletService = {
  getBalance,
  getLedger,
  verifyLedger,
  deposit,
  createCheckout,
};

export default walletService;
